"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditUsers = void 0;
const filter_header_1 = require("client/components/filter-header");
const list_1 = require("client/components/material/list");
const list_item_1 = require("client/components/material/list/list-item");
const list_item_text_1 = require("client/components/material/list/list-item/list-item-text");
const router_1 = require("client/components/router");
const upload_modal_1 = require("client/components/upload-modal");
const store_1 = require("client/modules/sites/modules/sites-detail/store");
const edit_user_1 = require("client/modules/users/modules/users-list/components/edit-user");
const store_ts_1 = require("client/modules/users/modules/users-list/store.ts");
const store_2 = require("client/modules/users/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const ramda_1 = require("ramda");
const React = require("react");
const react_1 = require("react");
const capitalize_string_1 = require("shared/util/capitalize-string");
const throttle_debounce_1 = require("throttle-debounce");
require("./edit-users.less");
const columns = [
    // {
    //   // avatar: true,
    //   center: false,
    //   id: "user.lastName",
    //   numeric: false,
    //   label: ""
    // },
    {
        center: false,
        id: "user.lastName",
        numeric: false,
        label: "Name"
    },
    {
        center: false,
        id: "user.email",
        numeric: false,
        label: "Email"
    },
    {
        center: false,
        id: "site.displayName",
        numeric: false,
        label: "Main Pharmacy"
    },
    {
        center: false,
        id: "group.name",
        numeric: false,
        label: "Role"
    }
];
const dummyUser = {
    email: "",
    firstName: "",
    groupId: 0,
    id: 0,
    lastName: "",
    phone: "",
    password: "",
    siteId: 0,
    verification: "",
    verified: false
};
let EditUsers = class EditUsers extends react_1.Component {
    constructor() {
        super(...arguments);
        this.confirmDeleteUser = null;
        this.order = "ASC";
        this.orderBy = "user.lastName";
        this.editId = -1;
        this.currentRowIndex = -1;
        this.isCollapse = true;
        this.filterText = "";
        this.autoFocusForm = true;
        this.uploadModal = false;
        this.user = ramda_1.merge(dummyUser, {});
        this.loadUsers = throttle_debounce_1.debounce(200, () => {
            if (store_1.sitesDetailStore.site.value) {
                store_1.sitesDetailStore.loadUsers({
                    allSites: true,
                    id: store_1.sitesDetailStore.site.value.id,
                    order: this.order,
                    search: this.filterText,
                    sort: this.orderBy
                });
            }
        });
        this.onCallback = (value) => {
            this.autoFocusForm = false;
            this.filterText = value;
            this.loadUsers();
        };
        this.onRequestSort = (property) => {
            if (this.orderBy === property) {
                this.order === "ASC" ? (this.order = "DESC") : (this.order = "ASC");
            }
            else {
                this.orderBy = property;
                this.order = "ASC";
            }
            this.loadUsers();
        };
        this.onHandleSave = async (user) => {
            this.user = user;
            let newUser;
            if (user.id) {
                newUser = await store_ts_1.usersListStore.saveUser(user);
            }
            else {
                newUser = await store_ts_1.usersListStore.createUser(user);
            }
            if (newUser) {
                await this.loadUsers();
                router_1.RouteManager.transitionTo(`/pharmacies/${this.siteId}/users/${newUser.id}`);
            }
        };
        this.onHandleClickDeleteUser = (user) => {
            this.confirmDeleteUser = user;
        };
        this.onHandleClickConfirmDeleteUser = () => {
            if (this.confirmDeleteUser) {
                store_ts_1.usersListStore.deleteUser(this.confirmDeleteUser);
                this.confirmDeleteUser = null;
            }
        };
        this.onHandleClickCancelDeleteUser = () => {
            this.confirmDeleteUser = null;
        };
        this.onHandleClickCancelUpload = () => {
            this.uploadModal = false;
        };
        this.onHandleClickDeleteUpload = async (upload) => {
            await store_2.usersStore.deleteUpload(upload);
            this.loadUsers();
        };
        this.onHandleCredentialUpload = (user) => {
            this.uploadType = "credential";
            this.uploadModal = true;
        };
        this.onHandleImageUpload = (user) => {
            this.uploadType = "image";
            this.uploadModal = true;
        };
        this.onHandleClickRow = (row, index) => {
            if (this.editId === row.id) {
                this.isCollapse = !this.isCollapse;
                this.autoFocusForm = true;
            }
            else {
                router_1.RouteManager.transitionTo(`/pharmacies/${this.siteId}/users/${row.id}`);
            }
            this.editId = row.id;
            this.currentRowIndex = index;
        };
        this.handleAssetsUpload = async (accepted) => {
            await store_2.usersStore.upload(accepted, String(this.editId), this.uploadType);
            this.loadUsers();
        };
        this.renderTable = () => (React.createElement("div", { className: "site-edit-users__table" }, store_1.sitesDetailStore.users.value && (React.createElement(list_1.MaterialList, { columns: columns, onRequestSort: this.onRequestSort, order: this.order, orderBy: this.orderBy, rows: store_1.sitesDetailStore.users.value, renderRow: this.renderTableRow, wideHeader: false, resizableheader: true, customClass: "custom-material-list__site-users-list" }))));
        this.renderEditNewUser = () => (React.createElement("div", { className: "users__new-user" },
            React.createElement(edit_user_1.EditUser, { autoFocusForm: this.autoFocusForm, error: store_ts_1.usersListStore.editUser.error, loading: store_ts_1.usersListStore.editUser.loading, onCancel: () => {
                    router_1.RouteManager.transitionTo(`/pharmacies/${this.siteId}/users`);
                    store_ts_1.usersListStore.editUser.error = undefined;
                }, onSave: this.onHandleSave, user: this.user, status: store_ts_1.usersListStore.editUser.status })));
        this.renderTableRow = (row, index) => {
            const isShowEdit = !this.isCollapse && this.props.userId === row.id;
            const tableRowContent = [this.renderTableRowPlain(row, index)];
            isShowEdit && tableRowContent.push(this.renderListRowEditMode(row, index));
            return tableRowContent;
        };
        this.renderTableRowPlain = (row, index) => {
            const displayName = row.firstName || row.lastName ? `${row.lastName}, ${row.firstName}` : "";
            const siteName = row.site
                ? row.site.displayName || row.site.name
                : CONFIG.emptyText;
            const groupName = row.group ? row.group.name : CONFIG.emptyText;
            return (React.createElement(list_item_1.MaterialListItem, { key: index, onClick: () => {
                    this.onHandleClickRow(row, index);
                } },
                React.createElement(list_item_text_1.MaterialListItemText, { className: "users__name", primary: capitalize_string_1.capitalizeString(displayName) }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: row.email }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: capitalize_string_1.capitalizeString(siteName) }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: capitalize_string_1.capitalizeString(groupName) })));
        };
        this.renderListRowEditMode = (row, index) => (React.createElement("div", { key: -1, className: "user-edit-form" },
            React.createElement(edit_user_1.EditUser, { autoFocusForm: this.autoFocusForm, error: store_ts_1.usersListStore.editUser.error, key: index, loading: store_ts_1.usersListStore.editUser.loading, onCancel: () => {
                    router_1.RouteManager.transitionTo(`/pharmacies/${this.siteId}/users`);
                    store_ts_1.usersListStore.editUser.error = undefined;
                }, onDelete: this.onHandleClickDeleteUser, onSave: this.onHandleSave, onCredentialUpload: this.onHandleCredentialUpload, onDeleteUpload: this.onHandleClickDeleteUpload, onImageUpload: this.onHandleImageUpload, user: row, status: store_ts_1.usersListStore.editUser.status })));
    }
    componentWillMount() {
        this.siteId = this.props.site ? this.props.site.id : 0;
    }
    componentWillReceiveProps(props) {
        this.user = ramda_1.merge(dummyUser, {});
        this.siteId = props.site ? props.site.id : 0;
        if (this.siteId) {
            this.user.siteId = this.siteId;
        }
        if (!this.props.userId) {
            this.isCollapse = true;
            this.editId = -1;
        }
        else {
            this.isCollapse = false;
        }
    }
    componentDidUpdate() {
        if (this.props.userId && this.editId !== this.props.userId) {
            this.isCollapse = false;
            this.editId = this.props.userId;
        }
        if (this.props.userId === 0) {
            this.isCollapse = false;
            this.editId = -1;
        }
        // When this.props.userId === 0, !this.props.providerId === true
        if (this.props.userId !== 0 && !this.props.userId) {
            this.isCollapse = true;
            this.editId = -1;
        }
    }
    render() {
        const newUserMode = this.props.userId === 0;
        return (React.createElement("div", { className: "site-edit-users" },
            newUserMode && this.renderEditNewUser(),
            this.renderFilter(),
            this.renderTable(),
            this.uploadModal && (React.createElement(upload_modal_1.UploadModal, { onCancel: this.onHandleClickCancelUpload, message: `Please select files for ${this.user.firstName} ${this.user.lastName}.`, title: "Upload Documents", onDrop: this.handleAssetsUpload, inPharmacy: true, callback: this.loadUsers }))));
    }
    renderFilter() {
        return (React.createElement("div", { className: "users__filter" },
            React.createElement(filter_header_1.FilterHeader, { callBack: this.onCallback, filterText: this.filterText })));
    }
};
__decorate([
    mobx_1.observable
], EditUsers.prototype, "confirmDeleteUser", void 0);
__decorate([
    mobx_1.observable
], EditUsers.prototype, "order", void 0);
__decorate([
    mobx_1.observable
], EditUsers.prototype, "orderBy", void 0);
__decorate([
    mobx_1.observable
], EditUsers.prototype, "editId", void 0);
__decorate([
    mobx_1.observable
], EditUsers.prototype, "currentRowIndex", void 0);
__decorate([
    mobx_1.observable
], EditUsers.prototype, "isCollapse", void 0);
__decorate([
    mobx_1.observable
], EditUsers.prototype, "filterText", void 0);
__decorate([
    mobx_1.observable
], EditUsers.prototype, "autoFocusForm", void 0);
__decorate([
    mobx_1.observable
], EditUsers.prototype, "uploadModal", void 0);
__decorate([
    mobx_1.observable
], EditUsers.prototype, "uploadType", void 0);
EditUsers = __decorate([
    mobx_react_1.observer
], EditUsers);
exports.EditUsers = EditUsers;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/sites/modules/sites-detail/components/edit-users/edit-users.tsx
// module id = 4068
// module chunks = 0